// extracted by mini-css-extract-plugin
module.exports = {"gymSelector":"styles_gymSelector__3R5vn","label":"styles_label__3Kmzj","inputSearch":"styles_inputSearch__aokfp","select":"styles_select__3t6vV"};